import { Button, HideFor, Size } from "@brightagency/headstart-common";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
// import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import React, { useRef } from "react";
import { useGlobalLinks, } from "../../../../services/app-state";
import { getAcfPostUrl } from "../../../../utils";
import { useSavedItems } from "../../../../utils/hooks";
import { IconAction } from "../../../atoms/IconAction";
import LockBodyScroll from "../../../atoms/LockBodyScroll";
import { MenuItem } from "../types";
import { MenuItems } from "./MenuItems";
import { MobileMenuHeader } from "./MobileMenuHeader";
import { Outer, Quicklinks, ButtonContainer, MenuItemsWrapper } from "./styled";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    items: MenuItem[];
}

export const MobileMenu: React.FC<Props> = props => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const { items: savedItems } = useSavedItems();
    const scrollingRef = useRef<HTMLDivElement>(null);

    return (
        <HideFor size={Size.large}>
            <Outer isOpen={props.isOpen} ref={scrollingRef}>
                {props.isOpen && <LockBodyScroll scrollingRef={scrollingRef} />}
                <MobileMenuHeader onClose={props.onClose} />
                <Quicklinks>
                    <div>
                        <IconAction onClick={props.onClose} icon={<HomeRoundedIcon />} to="/">
                            Home
                        </IconAction>
                    </div>
                    {/* <div>
                        <IconAction
                            onClick={props.onClose}
                            icon={<SearchRoundedIcon />}
                            to={getAcfPostUrl(getGlobalLink("local_services_page"))}
                        >
                            Services Languages
                        </IconAction>
                    </div> */}
                    <div>
                        <IconAction
                            onClick={props.onClose}
                            icon={<TranslateRoundedIcon />}
                            to={getAcfPostUrl(getGlobalLink("languages_page"))}
                        >
                            {getGlobalLink("languages_page").post_title}
                        </IconAction>
                    </div>
                    <div>
                        <IconAction
                            onClick={props.onClose}
                            icon={<StarRoundedIcon />}
                            to={getAcfPostUrl(getGlobalLink("saved_items_page"))}
                            showBadge={savedItems.length > 0}
                        >
                            {savedItems.length ? savedItems.length + " Saved" : "Saved"}
                        </IconAction>
                    </div>
                    <div>
                        <IconAction
                            onClick={props.onClose}
                            icon={<ChatRoundedIcon style={{ transform: "scale(0.85)" }} />}
                            to={getAcfPostUrl(getGlobalLink("feedback_page"))}
                        >
                            Feedback
                        </IconAction>
                    </div>
                </Quicklinks>
                <ButtonContainer>
                    <Button
                        appearance="secondary"
                        to={getAcfPostUrl(getGlobalLink("not_sure_where_to_begin_page"))}
                        onClick={props.onClose}
                    >
                        Not sure where to begin?
                    </Button>
                </ButtonContainer>
                <MenuItemsWrapper>
                    <MenuItems items={props.items} onNavigate={() => props.onClose()} />
                </MenuItemsWrapper>
            </Outer>
        </HideFor>
    );
};
